import { render, staticRenderFns } from "./CadastroBalancoHidrico.vue?vue&type=template&id=4ef5c882&scoped=true&"
import script from "./CadastroBalancoHidrico.vue?vue&type=script&lang=js&"
export * from "./CadastroBalancoHidrico.vue?vue&type=script&lang=js&"
import style0 from "./CadastroBalancoHidrico.vue?vue&type=style&index=0&id=4ef5c882&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef5c882",
  null
  
)

export default component.exports